import { useDateTimeFormat } from '@core/shared/src/hooks/useDateTimeFormat';
import { useTranslation } from 'react-i18next';
import { CompositePageHeaderProps } from './types';

export const CompositePageHeader = ({ title, broadcastDateTime: broadcastDateTimeStr }: CompositePageHeaderProps) => {
    const { t } = useTranslation();
    if (!broadcastDateTimeStr) return <></>;
    const { date: broadcastDate, time: broadcastTime } = useDateTimeFormat(broadcastDateTimeStr);
    return (
        <>
            <p>
                <span className="font-normal inline-block min-w-[52px] mr-1">{t('CompositePageHeader.Label.Event')}</span>
                <span className="text-xl md:text-2xl">{title}</span>
            </p>
            <p>
                <span className="font-normal inline-block min-w-[52px] mr-1">{t('CompositePageHeader.Label.Date')}</span>
                <span>
                    {broadcastDate}
                    &nbsp;
                    {broadcastTime}
                </span>
            </p>
        </>
    );
};
